<template>
	<div class="drawer">
		<el-drawer
		size="620px"
		title="活体筛选"
		:visible.sync="drawerStatus"
		@close='handleClose'
		:append-to-body="false"
		>
			<div class="popCon">
				<div class="popTit" style="padding-left:12px;padding-right: 12px;">
					<span>按条件筛选</span>
					<el-button type="text" @click="reset" size="mini" style="margin:0 10px 5px 0;font-size: 14px;">重置</el-button>
				</div>
				<div class="popForm">
					<!-- <div class="popLine">
						<div class="popLabel">活动促销</div>
						<div class="popValue">
							<div
							class="popValueItem"
							:class="[hasActivity==='0'?'active':'']"
							@click="changeHasActivity('0')"
							v-for="(item,indexActivity) in [{label:'全部',value:-1},{label:'是',value:1},{label:'否',value:2}]"
							:key="indexActivity"
							>
								{{item.label}}
							</div>
						</div>
					</div> -->
					<div class="popLine">
						<div class="popLabel">宠物类型</div>
						<div class="popValue">
							<div class="popValueItem" :class="[petClass1==='0'?'active':'']" @click="changePetClass1('0')">全部</div>
							<div class="popValueItem" :class="[petClass1==='1'?'active':'']" @click="changePetClass1('1')">猫猫</div>
							<div class="popValueItem" :class="[petClass1==='2'?'active':'']" @click="changePetClass1('2')">狗狗</div>
						</div>
					</div>
					<div class="popLine">
						<div class="popLabel">宠物性别</div>
						<div class="popValue">
							<div class="popValueItem" :class="[petSex1==='0'?'active':'']" @click="changePetSex1('0')">全部</div>
							<div class="popValueItem" :class="[petSex1==='1'?'active':'']" @click="changePetSex1('1')">公</div>
							<div class="popValueItem" :class="[petSex1==='2'?'active':'']" @click="changePetSex1('2')">母</div>
						</div>
					</div>
					<div class="popLine">
						<div class="popLabel">宠物种类</div>
						<div class="popValue">
							<div
							class="popValueItem"
							:class="petType1.indexOf(typeItem.id)>-1?'active':''"
							@click="changePetType1(typeItem)"
							v-for="(typeItem,typeIndex) in typeList"
							:key="typeIndex"
							>
								{{typeItem.label}}
							</div>
						</div>
						<!-- <div class="popMult">
							*多选
						</div> -->
					</div>
					<div class="popLine">
						<div class="popLabel">颜色</div>
						<div class="popValue">
							<div
							class="popValueItem"
							:class="petColor1.indexOf(colorItem.name)>-1?'active':''"
							@click="changePetColor1(colorItem)"
							v-for="(colorItem,colorIndex) in colorList"
							:key="colorIndex"
							>
								{{colorItem.name}}
							</div>
						</div>
						<div class="popMult">
							*多选
						</div>
					</div>
					<div class="popLine">
						<div class="popLabel">特征</div>
						<div class="popValue">
							<div class="popValueItem" :class="petFeatures1.indexOf('全部')>-1?'active':''" @click="changePetFeatures1('全部')">全部</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('立耳')>-1?'active':''" @click="changePetFeatures1('立耳')">立耳</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('折耳')>-1?'active':''" @click="changePetFeatures1('折耳')">折耳</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('矮脚')>-1?'active':''" @click="changePetFeatures1('矮脚')">矮脚</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('长毛')>-1?'active':''" @click="changePetFeatures1('长毛')">长毛</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('卷耳')>-1?'active':''" @click="changePetFeatures1('卷耳')">卷耳</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('飞耳')>-1?'active':''" @click="changePetFeatures1('飞耳')">飞耳</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('不断尾')>-1?'active':''" @click="changePetFeatures1('不断尾')">不断尾</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('福1')>-1?'active':''" @click="changePetFeatures1('福1')">福1</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('福2')>-1?'active':''" @click="changePetFeatures1('福2')">福2</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('福3')>-1?'active':''" @click="changePetFeatures1('福3')">福3</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('福4')>-1?'active':''" @click="changePetFeatures1('福4')">福4</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('福2+3')>-1?'active':''" @click="changePetFeatures1('福2+3')">福2+3</div>
							<div class="popValueItem" :class="petFeatures1.indexOf('特')>-1?'active':''" @click="changePetFeatures1('特')">特</div>
						</div>
						<div class="popMult">
							*多选
						</div>
					</div>
					<div class="popLine">
						<div class="popLabel">疫苗针数</div>
						<div class="popValue">
							<div class="popValueItem" :class="petNeedleNumber1.indexOf('全部')>-1?'active':''" @click="changePetNeedleNumber1('全部')">全部</div>
							<div class="popValueItem" :class="petNeedleNumber1.indexOf('1')>-1?'active':''" @click="changePetNeedleNumber1('1')">第一针</div>
							<div class="popValueItem" :class="petNeedleNumber1.indexOf('2')>-1?'active':''" @click="changePetNeedleNumber1('2')">第二针</div>
							<div class="popValueItem" :class="petNeedleNumber1.indexOf('3')>-1?'active':''" @click="changePetNeedleNumber1('3')">第三针</div>
							<div class="popValueItem" :class="petNeedleNumber1.indexOf('4')>-1?'active':''" @click="changePetNeedleNumber1('4')">第四针</div>
						</div>
						<div class="popMult">
							*多选
						</div>
					</div>
					<div class="popLine">
						<div class="popLabel">月份</div>
						<div class="popValue">
							<div class="popValueItem" :class="petAge1.indexOf('0,0')>-1?'active':''" @click="changePetAge1('0,0')">全部</div>
							<div class="popValueItem" :class="petAge1.indexOf('0,3')>-1?'active':''" @click="changePetAge1('0,3')">0个月~3个月</div>
							<div class="popValueItem" :class="petAge1.indexOf('3,6')>-1?'active':''" @click="changePetAge1('3,6')">3个月~6个月</div>
							<div class="popValueItem" :class="petAge1.indexOf('6,9')>-1?'active':''" @click="changePetAge1('6,9')">6个月~9个月</div>
							<div class="popValueItem" :class="petAge1.indexOf('9,12')>-1?'active':''" @click="changePetAge1('9,12')">9个月~12个月</div>
							<div class="popValueItem" :class="petAge1.indexOf('12,10000')>-1?'active':''" @click="changePetAge1('12,10000')">大于12个月</div>
						</div>
					</div>
					<div class="popLine">
						<div class="popLabel">到店时间</div>
						<div class="popValue">
							<div class="popValueItem" :class="addDay1===0?'active':''" @click="changeAddDay1(0)">不限</div>
							<div class="popValueItem" :class="addDay1===7?'active':''" @click="changeAddDay1(7)">7天内</div>
							<div class="popValueItem" :class="addDay1===15?'active':''" @click="changeAddDay1(15)">15天内</div>
						</div>
					</div>
				</div>
			</div>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="handleClose">取消</div>
				<div class="btnItem submit" @click="submitCode">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				
				typeList:[],
				typeList1:[],
				typeList2:[],
				colorList:[],
				
				petClass1:'',
				petSex1:'',
				petType1:[''],
				petColor1:['全部'],
				petFeatures1:['全部'],
				petNeedleNumber1:['全部'],
				petAge1:['0,0'],
				addDay1:0,
				
			}
		},
		props:{
			petClass:{
				default:''
			},
			petSex:{
				default:''
			},
			petType:{
				default:()=>{
					return ['']
				}
			},
			petColor:{
				default:()=>{
					return ['全部']
				}
			},
			petFeatures:{
				default:()=>{
					return ['全部']
				}
			},
			petNeedleNumber:{
				default:()=>{
					return ['全部']
				}
			},
			petAge:{
				default:()=>{
					return ['0,0']
				}
			},
			addDay:{
				default:()=>{
					return 0
				}
			},
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
			this.petClass1 = this.petClass;
			this.petSex1 = this.petSex;
			this.petType1 = JSON.parse(JSON.stringify(this.petType));
			this.petColor1 = JSON.parse(JSON.stringify(this.petColor));
			this.petFeatures1 = JSON.parse(JSON.stringify(this.petFeatures));
			this.petNeedleNumber1 = JSON.parse(JSON.stringify(this.petNeedleNumber));
			this.petAge1 = JSON.parse(JSON.stringify(this.petAge));
			this.addDay1 = Number(this.addDay);
			this.getColorListByCategoryId()
			let params = {
				category: '活体'
			}
			this.$http.get('/api/Product/Category/Tree', params).then(res => {
				if(res.code===0){
					for(let i=0;i<res.data[0].children.length;i++){
						let item = res.data[0].children[i];
						if(item.id==='603f7255664b790a9c7d4f61'){
							let a = [{label:'全部',id:''}];
							this.typeList1 = a.concat(item.children);
						}
						if(item.id==='603f7255664b790a9c7d4f62'){
							let b = [{label:'全部',id:''}];
							this.typeList2 = b.concat(item.children);
						}
					}
					let typelist1 = JSON.parse(JSON.stringify(this.typeList1))
					let typelist2 = JSON.parse(JSON.stringify(this.typeList2))
					typelist2.splice(0,1);
					this.typeList = typelist1.concat(typelist2);
				}
			})
			
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submitCode(){
				let obj = {
					petClass:this.petClass1,
					petSex:this.petSex1,
					petType:this.petType1,
					petColor:this.petColor1,
					petFeatures:this.petFeatures1,
					petNeedleNumber:this.petNeedleNumber1,
					petAge:this.petAge1,
					addDay:this.addDay1,
				}
				this.$emit('submit',{type:'success',data:obj})
			},
			changePetClass1(str){
				this.petClass1 = str;
				if(str==='0'){
					let typelist1 = JSON.parse(JSON.stringify(this.typeList1))
					let typelist2 = JSON.parse(JSON.stringify(this.typeList2))
					typelist2.splice(0,1);
					this.typeList = typelist1.concat(typelist2);
					this.petType1=['']
				}else if(str==='1'){
					let typelist1 = JSON.parse(JSON.stringify(this.typeList1))
					this.typeList = typelist1;
					this.petType1=['']
				}else if(str==='2'){
					let typelist2 = JSON.parse(JSON.stringify(this.typeList2))
					this.typeList = typelist2;
					this.petType1=['']
				}
			},
			changePetSex1(str){
				this.petSex1 = str;
			},
			changePetType1(item){
				// if(item.id===''){
				// 	this.petType1 = ['']
				// }else{
				// 	let index0 = -1
				// 	for(let a=0;a<this.petType1.length;a++){
				// 		if(this.petType1[a]===''){
				// 			index0 = a;
				// 		}
				// 	}
				// 	if(index0>-1){
				// 		this.petType1.splice(index0,1)
				// 	}
				// 	let index = -1;
				// 	for(let i=0;i<this.petType1.length;i++){
				// 		if(this.petType1[i]===item.id){
				// 			index = i;
				// 		}
				// 	}
				// 	if(index===-1){
				// 		this.petType1.push(item.id);
				// 	}else{
				// 		this.petType1.splice(index,1)
				// 	}
				// }
				// if(this.petType1.length===0){
				// 	this.petType1 = ['']
				// }
				this.petType1 = [item.id]
				this.getColorListByCategoryId()
			},
			changePetColor1(item){
				if(item.name==='全部'){
					this.petColor1 = ['全部']
				}else{
					let index0 = -1
					for(let a=0;a<this.petColor1.length;a++){
						if(this.petColor1[a]==='全部'){
							index0 = a;
						}
					}
					if(index0>-1){
						this.petColor1.splice(index0,1)
					}
					let index = -1;
					for(let i=0;i<this.petColor1.length;i++){
						if(this.petColor1[i]===item.name){
							index = i;
						}
					}
					if(index===-1){
						this.petColor1.push(item.name);
					}else{
						this.petColor1.splice(index,1)
					}
				}
				if(this.petColor1.length===0){
					this.petColor1 = ['全部']
				}
			},
			changePetFeatures1(str){
				if(str==='全部'){
					this.petFeatures1 = ['全部']
				}else{
					let index0 = -1
					for(let a=0;a<this.petFeatures1.length;a++){
						if(this.petFeatures1[a]==='全部'){
							index0 = a;
						}
					}
					if(index0>-1){
						this.petFeatures1.splice(index0,1)
					}
					let index = -1;
					for(let i=0;i<this.petFeatures1.length;i++){
						if(this.petFeatures1[i]===str){
							index = i;
						}
					}
					if(index===-1){
						this.petFeatures1.push(str);
					}else{
						this.petFeatures1.splice(index,1)
					}
				}
				if(this.petFeatures1.length===0){
					this.petFeatures1 = ['全部']
				}
			},
			changePetNeedleNumber1(str){
				if(str==='全部'){
					this.petNeedleNumber1 = ['全部']
				}else{
					let index0 = -1
					for(let a=0;a<this.petNeedleNumber1.length;a++){
						if(this.petNeedleNumber1[a]==='全部'){
							index0 = a;
						}
					}
					if(index0>-1){
						this.petNeedleNumber1.splice(index0,1)
					}
					let index = -1;
					for(let i=0;i<this.petNeedleNumber1.length;i++){
						if(this.petNeedleNumber1[i]===str){
							index = i;
						}
					}
					if(index===-1){
						this.petNeedleNumber1.push(str);
					}else{
						this.petNeedleNumber1.splice(index,1)
					}
				}
				if(this.petNeedleNumber1.length===0){
					this.petNeedleNumber1 = ['全部']
				}
			},
			changePetAge1(str){
				if(this.petAge1[0]===str){
					this.petAge1 = ['0,0']
				}else{
					this.petAge1 = [str]
				}
			},
			changeAddDay1(num){
				this.addDay1 = num;
			},
			reset(){
				this.petClass1 = '0';
				this.petSex1 = '0';
				this.petColor1 = ['全部'];
				this.petFeatures1 = ['全部'];
				this.petNeedleNumber1 = ['全部'];
				this.petAge1 = ['0,0'];
				this.addDay1 = 0;
				// 分类
				this.petType1=[''];
				let typelist1 = JSON.parse(JSON.stringify(this.typeList1))
				let typelist2 = JSON.parse(JSON.stringify(this.typeList2))
				typelist2.splice(0,1);
				this.typeList = typelist1.concat(typelist2);
				this.getColorListByCategoryId()
			},
			// 获取毛色列表
			// getColorList() {
			// 	this.colorList = [{name:'全部'}];
			// 	let params = {
			// 		"keyword": "",
			// 		"pageIndex": 1,
			// 		"pageSize": 1000
			// 	}
			// 	this.$http.post('/api/DataCenter/List', params).then(res => {
			// 		if (res.code == 0) {
			// 			this.colorList = this.colorList.concat(res.data.data);
			// 		}
			// 	})
			// },
			getColorListByCategoryId() {
				this.colorList = [{name:'全部'}];
				let params = {
					"categoryId": this.petType1.join(','),
				}
				this.$http.get(process.env.VUE_APP_Url_baseData+'/api/product/pet/category/color', params).then(res => {
					if (res.code == 0) {
						this.colorList = this.colorList.concat(res.data.map((c)=>{return {name:c}}));
						this.petColor1 = ['全部']
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		
		::v-deep.el-drawer{
			.el-drawer__body{
				overflow: auto;padding:0 0 50px;
				.popCon{
					width:620px;
					.popTit{
						border-bottom:1px solid rgba(0, 0, 0, 0.06);font-size: 14px;color:#1A1A1A;display: flex;justify-content: space-between;
						.resetScreen{
							background-color: #1890FF;font-size: 12px;color:#fff;border-radius: 2px;padding:0 10px;line-height: 24px;margin-right: 15px;cursor: pointer;
						}
					}
					.popForm{
						.popLine{
							padding:10px 5px;display: flex;
							.popLabel{
								font-size: 12px;color:#9C9C9C;width:55px;text-align: right;;margin:5px 0px 5px 0;line-height: 34px;
							}
							.popValue{
								display: flex;width:508px;flex-wrap: wrap;
								.popValueItem{
									// font-size: 12px;color:#1A1A1A;padding:0 10px;border-right: 1px solid #D3D3D3;cursor: pointer;margin:5px 0;
									width:90px;line-height: 32px;font-size: 12px;text-align: center;background-color: #EFEFEF;border-radius: 17px;margin:4px;border:1px solid #fff;cursor: pointer;white-space: nowrap;
									&:hover{
										color:#1890FF;
									}
									&.active{
										color:#1890FF;border-color:#1890FF;background-color: #1890FF11;
									}
								}
							}
							.popMult{
								width:34px;color:#FF182A;font-size: 12px;
							}
						}
					}
				}
			}
			
		}
		
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
